import { useEffect, useState } from "react";

type Theme = "system" | "light" | "dark";
const STORAGE_KEY = "lf-theme";

function apply(theme: Theme) {
  const root = document.documentElement;
  if (theme === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme);
}

/** Read the stored preference before first paint to avoid a flash. */
export function initTheme() {
  const stored = localStorage.getItem(STORAGE_KEY) as Theme | null;
  apply(stored ?? "system");
}

const NEXT: Record<Theme, Theme> = { system: "light", light: "dark", dark: "system" };
const ICON: Record<Theme, string> = { system: "◐", light: "☀", dark: "☾" };

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem(STORAGE_KEY) as Theme | null) ?? "system",
  );

  useEffect(() => {
    apply(theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  return (
    <button
      type="button"
      className="btn btn--ghost btn--icon"
      onClick={() => setTheme(NEXT[theme])}
      title={`Theme: ${theme}`}
      aria-label={`Switch theme (currently ${theme})`}
    >
      <span aria-hidden>{ICON[theme]}</span>
    </button>
  );
}
